import React, { memo } from 'react';

import bn from '../../generalUtils/benames';

const bemClass = bn.create('customCheckbox');

const CustomCheckbox = props => {
  const {
    id,
    name = undefined,
    value,
    checked,
    onChange,
    disabled = false,
    labelName = '',
    className = '',
    inputClassName = '',
    labelClassName = undefined,
    checkboxClassName = undefined,
    color = 'primary'
  } = props;

  const isAddDisableClass = disabled ? 'disabledToggle' : '';
  const chkId = id ? id?.toString()?.trim() : null;

  return (
    <div className={`${bemClass.b(className)}`}>
      <input
        type="checkbox"
        id={chkId}
        name={name}
        className={`customCheckbox-input ${checked ? 'checked' : ''} ${isAddDisableClass} ${inputClassName}`}
        checked={checked || false}
        onChange={onChange}
        disabled={disabled}
        value={value}
      />
      <label
        htmlFor={chkId}
        className={`customCheckbox-label ${
          checked ? `btn-${color} b-${color}-100` : `btn-dark-400 b-secondary-100`
        } ${disabled ? 'disabled' : ''} ${checkboxClassName || ''}`}
        data-checked={checked || false}
      />

      {labelName && (
        <label
          title={disabled ? 'Disabled' : typeof labelName === 'string' ? labelName : ''}
          htmlFor={chkId}
          data-checked={checked || false}
          className={`checkboxlabel ${labelClassName || ''} ${isAddDisableClass}`}
        >
          {labelName}
        </label>
      )}
    </div>
  );
};

CustomCheckbox.displayName = 'CustomCheckbox';
export default memo(CustomCheckbox);
